export default __webpack_public_path__ + "static/media/logo.956a746d.svg";